export default {
  title: 'Bienvenido',
  subtitle: 'Mi Pago Claro'
};
